module.exports = __webpack_public_path__ + "img/amex.363ffbf6.svg";